import { render } from "./SliderRangeCommand.vue?vue&type=template&id=089ac965&scoped=true"
import script from "./SliderRangeCommand.vue?vue&type=script&lang=js"
export * from "./SliderRangeCommand.vue?vue&type=script&lang=js"

import "./SliderRangeCommand.vue?vue&type=style&index=0&id=089ac965&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089ac965"]])

export default __exports__